import { Box, BoxProps, Spinner } from '@chakra-ui/react';
import React from 'react';

import { StepStatusEnumGQLType } from 'types/dashboard-core-gqlTypes.generated';

import {
  FiCircle,
  FiCheckCircle,
  FiXCircle,
  FiAlertCircle,
} from 'react-icons/fi';

type VerificationStatusIconProps = { status: StepStatusEnumGQLType } & BoxProps;
export const VerificationStatusIcon = ({
  status,
  ...boxProps
}: VerificationStatusIconProps) => {
  return (
    <Box {...boxProps}>
      {status === 'notStarted' && (
        <FiCircle
          stroke="currentColor"
          style={{ color: 'gray', width: '20px', height: '20px' }}
        />
      )}
      {status === 'inProgress' && <Spinner color="green" />}
      {status === 'success' && (
        <FiCheckCircle
          stroke="currentColor"
          style={{ color: 'green', width: '20px', height: '20px' }}
        />
      )}
      {status === 'error' && (
        <FiXCircle
          stroke="currentColor"
          style={{ color: 'red', width: '20px', height: '20px' }}
        />
      )}
      {status === 'remediationRequested' && (
        <FiAlertCircle
          stroke="currentColor"
          style={{ color: 'red', width: '20px', height: '20px' }}
        />
      )}
    </Box>
  );
};
